import Company from '@/models/Company'
import User, { hasRole, Role } from '@/models/User'

export default class CompanyPolicy {
    viewAny(_user: User) {
        return false
    }

    view(_user: User, _company: Company) {
        return false
    }

    create(_user: User) {
        return false
    }

    update(_user: User, _company: Company) {
        return false
    }

    restore(_user: User, _company: Company) {
        return false
    }

    delete(_user: User, _company: Company) {
        return false
    }

    forceDelete(_user: User, _company: Company) {
        return false
    }

    invite(user: User, company: Company) {
        return hasRole(user, Role.USER) && user.company?.id === company.id
    }
}
